import { UnknownBlueprint } from '../types';

export const u3 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:3:unsupported');
	inBlueprint.schemaVersion = 3;
	return [inBlueprint, false];
};
